var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._v("\n    © 2021 Betta Games. All rights reserved.\n    "),_vm._v(" "),_c('a',{staticStyle:{"margin-left":"40px"},attrs:{"target":"_blank","href":"https://beian.miit.gov.cn/#/Integrated/recordQuery"}},[_vm._v("京ICP备12035264号")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-633fbc22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/homeFoot.vue
// module id = null
// module chunks = 